import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import RepurchaseTable from "../../components/shopping/RepurchaseTable";
import { ApiHook } from "../../hooks/apiHook";
import EcomRepurchaseTable from "../../components/shopping/EcomRepurchaseTable";

const EcomRepurchaseReport = () => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortOptions, setSortOptions] = useState({
    sortBy: "",
    direction: ""
  })
  //-------------------------------- API ---------------------------------------
  const report = ApiHook.CallEcomRepurchaseReport(currentPage,itemsPerPage, sortOptions.sortBy, sortOptions.direction)
  
  return (
    <>
      <div className="page_head_top">{t("repurchase_report")}</div>
      <EcomRepurchaseTable
        data={report.data}
        type={"ecom-repurchase-report"}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        setSortOptions={setSortOptions}
      />
    </>
  );
};

export default EcomRepurchaseReport;
